import $cookies from 'vue-cookies'

export default (to, from, next) => {
  const { signupManage } = to.query

  if (signupManage) {
    $cookies.set('signupManage', signupManage, 0)
  }
  next()
}
